import React from 'react';
import { Hero } from '../components/Hero';
import { Hook } from '../components/Hook';
import { Problem } from '../components/Problem';
import { WhyFailed } from '../components/WhyFailed';
import { Mechanism } from '../components/Mechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoFor } from '../components/WhoFor';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { FAQ } from '../components/FAQ';
import { Offer } from '../components/Offer';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full bg-ink font-sans text-cream" data-id="element-193">
      <Hero data-id="element-194" />
      <Hook data-id="element-195" />
      <Problem data-id="element-196" />
      <WhyFailed data-id="element-197" />
      <Mechanism data-id="element-198" />
      <WhatYouGet data-id="element-199" />
      <WhoFor data-id="element-200" />
      <HowItWorks data-id="element-201" />
      <Proof data-id="element-202" />
      <FAQ data-id="element-203" />
      <Offer data-id="element-204" />
      <Footer data-id="element-205" />
    </main>;
}